import React from "react"

export const BecomeAMerchant = () => {
    return (
    <div className="support-faq container py-4">
        <h3>Become A Merchant</h3>
    </div>
    )
}